<div class="container">
  <site-search [placeholder]="'placeholder_search' | transloco"></site-search>
  <button mat-icon-button
          matTooltip="{{'display_filters' | transloco}}"
          [color]="(sitesFiltersDefined) ? 'accent' : 'undefined'"
          (click)="openFilters()">
    tune
  </button>
</div>
